import React, { useState, memo, useEffect } from "react";
import "./Seasonality.css";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import { useNavigate, useLocation } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import excel from "../../../../Assets/Images/excel.png";
import { Button } from "@mui/material"; 
import { commonFormatNumber } from "../../../../helpers/dataHelper";
import { converJsonToExcel } from "../../../../helpers/excelHelper";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";

let seasonalArray = [];
const stringConstant = {
  min : "Min. Temp (f)",
  max : "Max. Temp (f)"
}
const applyToArray = (func, array) => func.apply(Math, array);
let seasonalityList = [];
const Seasonality = memo((props) => {
  const [totalPage, setTotalPage] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderBy] = useState("profileName");
  const [orderDirection, setOrderDirection] = useState(true);
  // const marketId = localStorage.getItem("marketId")
  //   ? localStorage.getItem("marketId")
  //   : null;
  const marketId = props && props.marketId ? props.marketId : null;
  const [seasonalityData, setSeasonalityTable] = useState([]);
  const [seasonalAnalysis, setSeasonalAnalysis] = useState([]);
  const [apexValue, setApexValue] = useState({
    series: [],
    options: {
      // annotations: {
      //   yaxis: [
      //     {
      //       y: 0,
      //       borderColor: "#00E396",
      //       label: {
      //         borderColor: "#00E396",
      //       },
      //     },
      //   ],
      // },
      chart: {
        height: 350,
        type: "line",
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: false,
            selection: true,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: [],
          },
        },
      },
      stroke: {
        curve: "smooth",
        width: 1.5,
      },
      fill: {
        type: "solid",
        opacity: 0.3,
      },
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep ",
        "Oct",
        "Nov",
        "Dec",
      ],
      markers: {
        size: 0,
      },
      // yaxis: [
      //   {
      //     labels: {
      //       formatter: (value) => {
      //         return value + " F";
      //       },
      //     },
      //   },
      // ],
      colors: ["#000000", "#5b9f48", "#d51f29"],
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y, x) {
            if (typeof y !== "undefined") {
              let caption =
                x.w.config.colors[x.seriesIndex] === "#000000" ? " in" : " °";
              return y.toFixed(2) + caption;
            }
            return y;
          },
        },
      },
    },
  });

  //get seasonality data
  useEffect(() => {
    seasonalityList = [];
  }, []);

  //move to next page of the records
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //change the display rows per page in record
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
  };
  const handleInfiniteOnLoad = () => {
    // if (page !== totalPage) {
      setPage(page + 1);
    // }
  };

  const downloadData = () => {
    let inputData={orderBy: orderBy,
        orderDirection: orderDirection ? "Asc" : "Desc",
        marketId: marketId,
        forDownload: true,}
      apiCommonTrigger("post",`${Config.API_URL}/markets/market/analysis/seasonality`,inputData)
   .then((res) => {
      if (res.status === 200) {
        var data = res.data;
        converJsonToExcel({seasonaldata : data.seasonaldata} , "MarketSeasonalData");
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //call rvlist based on the below changes
  useEffect(() => {
    if(page === 1 || page <= totalPage){
    getSeasonalityData();
    }
  }, [page, orderDirection]);


  function formatNumbersValue(data) {
  
    function recursiveFormat(obj) {
      for (let key in obj) {
        if (Array.isArray(obj[key])) {
          // If it's an array, iterate through the items
          obj[key].forEach(item => {
            if (typeof item === 'object') {
              recursiveFormat(item);  // Recursive call for nested objects
            } else {
              item = commonFormatNumber(item);
            }
          });
        } else if (typeof obj[key] === 'object') {
          // If it's a nested object, recurse into it
          recursiveFormat(obj[key]);
        } else {
          // Format the value if it's numeric
          obj[key] = commonFormatNumber(obj[key]);
        }
      }
    }
  
    // Start recursion on the main data object
    recursiveFormat(data);
    return data;
  }

  //call seasonality api
  const getSeasonalityData = async () => {
    setLoading(true);
    let inputData={ marketId: marketId,
        page: page,
        resultsPerPage: rowsPerPage,
        orderBy: orderBy,
        orderDirection: orderDirection ? "Asc" : "Desc",}
      
    await apiCommonTrigger("post",`${Config.API_URL}/markets/market/analysis/seasonality`,inputData) .then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (page === 1) {
          seasonalityList = [];
          seasonalArray = [];
        }
        let sampleData = [];
        let color = [];
        let showPrecipitation = false;
        let precValues = [];
        let tempValues = [];
        if (res.data.seasonalsummaries.length > 0) {
          res.data.seasonalsummaries.map((data) => {
            if (data.weatherdata === "precipitation") {
              showPrecipitation = true;
              for (var i = 0; i < Object.keys(data).length; i++) {
                if (
                  Object.values(data)[i] !== "precipitation" &&
                  Object.values(data)[i] !== null
                ) {
                  precValues.push(Object.values(data)[i]);
                }
              }
            } else {
              for (var i = 0; i < Object.keys(data).length; i++) {
                if (
                  Object.values(data)[i] !== "max. temp (f)" &&
                  Object.values(data)[i] !== "min. temp (f)" &&
                  Object.values(data)[i] !== null
                ) {
                  tempValues.push(Object.values(data)[i]);
                }
              }
            }
            sampleData.push({
              name:
                data.weatherdata === "precipitation"
                  ? data.weatherdata.charAt(0).toUpperCase() + data.weatherdata.slice(1) + " (in)"
                  : data.weatherdata.includes('min') ? stringConstant.min : stringConstant.max ,
              type: data.weatherdata === "precipitation" ? "area" : "line",
              data: [
                data.january ? data.january : 0,
                data.february ? data.february : 0,
                data.march ? data.march : 0,
                data.april ? data.april : 0,
                data.may ? data.may : 0,
                data.june ? data.june : 0,
                data.july ? data.july : 0,
                data.august ? data.august : 0,
                data.september ? data.september : 0,
                data.october ? data.october : 0,
                data.november ? data.november : 0,
                data.december ? data.december : 0,
              ],
            });
            color.push(
              data.weatherdata === "precipitation"
                ? "#000000"
                : data.weatherdata === "max. temp (f)"
                ? "#5b9f48"
                : "#d51f29"
            );
          });
          let preciMinMax = [
            applyToArray(Math.min, precValues),
            applyToArray(Math.max, precValues),
          ];
          let tempMinMax = [
            applyToArray(Math.min, tempValues),
            applyToArray(Math.max, tempValues),
          ];
          setApexValue({
            ...apexValue,
            series: sampleData,
            options: {
              colors: color,
              noData: {
                text: "",
              },
              axisBorder: {
                show: true,
              },
              yaxis: [
                {
                  seriesName: 'Min. Temp (f)',
                  show: true,
                  title: {
                    text: "Avg. Temperature (F)",
                  },
                  labels: {
                    formatter: (value) => {
                      return value.toFixed(2);
                    },
                  },
                },
                {
                  seriesName: 'Max. Temp (f)',                 
                  show: false,
                },
               {
                  show: showPrecipitation,
                  opposite: showPrecipitation,
                  title: {
                    text: "Avg. Precipitation (in)",
                  },
                  seriesName: 'Precipitation',
                },
              ],
            },
          });
        } else {
          setApexValue({
            ...apexValue,
            series: [],
            options: {
              colors: color,
              noData: {
                text: "No Data Found",
                verticalAlign: "middle",
                style: { color: "red", fontSize: "12px" },
              },
              optionsLine: { chart: { height: 0 } },
              xaxis: {
                axisBorder: {
                  show: false,
                },
              },
              yaxis: {
                labels: { show: false },
                axisBorder: {
                  show: false,
                },
              },
            },
          });
        }

        seasonalityList.push(res.data);
        setTotalPage(res.data.pagination.totalpages);
        seasonalityList.map((data) => {
          const avg_priceResult = data.seasonaldata.reduce(function (
            results,
            org
          ) {
            (results[org.profilename] = results[org.profilename] || []).push(org);
            return results;
          },
          {});
          seasonalArray.push(avg_priceResult);
        });
        let filteredseasonalArray = Array.from(
          new Set(seasonalArray.map(JSON.stringify)),
          JSON.parse
        );
        const formattedSeasonalData = formatNumbersValue(filteredseasonalArray);
        setSeasonalAnalysis(formattedSeasonalData);
      } else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  return (
    <div className="season-tab">
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div>
        <div className="table-legend">
          <span>Showing the average weather data of 5 years by month</span>
        </div>
        <div id="chart" className="chart-phbs chart-box">
          <div className="chart-main">
            <ReactApexChart
              options={apexValue && apexValue.options && apexValue.options}
              series={apexValue && apexValue.series && apexValue.series}
              type="line"
              height={320}
            />
          </div>
        </div>
        <div></div>
      </div>
      <div className="seasonal-list"> 
        {seasonalityList && seasonalityList[0] && 
        seasonalityList[0].seasonaldata &&
        seasonalityList[0].seasonaldata.length > 0 ? (
          <Button onClick={() => downloadData()} className="excel-download">
            {" "}
            <img src={excel} alt="Excel Download" />
            Download
          </Button>
        ) : (
          ""
        )}
        <div className="clear"></div>
      </div>
      <div className="season-table table-height">
        <InfiniteScroll
          initialLoad={false}
          loadMore={handleInfiniteOnLoad}
          hasMore={page !== totalPage}
          threshold={20}
          useWindow={false}
        >
           {seasonalAnalysis && Object.keys(seasonalAnalysis).length !== 0 ? (
            <Table className="table-design">
              <TableHead>
                <TableRow key= "design">
                  <TableCell
                    id="sort-amenities"
                    onClick={() => {
                      setOrderDirection(!orderDirection);
                      setOrderBy("profilename");
                      setPage(1);
                    }}
                  >
                    Campgrounds {orderDirection ? <ArrowDown /> : <ArrowUp />}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell>Jan</TableCell>
                  <TableCell>Feb</TableCell>
                  <TableCell>Mar</TableCell>
                  <TableCell>Apr</TableCell>
                  <TableCell>May</TableCell>
                  <TableCell>Jun</TableCell>
                  <TableCell>Jul</TableCell>
                  <TableCell>Aug</TableCell>
                  <TableCell>Sep</TableCell>
                  <TableCell>Oct</TableCell>
                  <TableCell>Nov</TableCell>
                  <TableCell>Dec</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {seasonalAnalysis && seasonalAnalysis.length > 0 ? (
                  seasonalAnalysis.map((x) => {
                    let dt = Object.values(x);
                    return dt.map((sampleData) => {
                      return sampleData.map((data, index) => {
                        return (
                          <React.Fragment>
                            <TableRow key={data.profileid}>
                              {index === 0 ? (
                                <TableCell
                                  rowSpan={sampleData.length}
                                  className="profile-name"
                                >
                                  {data.profilename}
                                </TableCell>
                              ) : (null)}
                              <TableCell>
                                {data.status === "avg. temp (f)"
                                  ? "Avg. Temp (f)"
                                  : data.status === "avgprecipitation"
                                  ? "Avg. Precipitation (in)"
                                  : "Status"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.january === "Open"
                                    ? "green-text"
                                    : data.january === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.january
                                    ? data.january
                                    : "-"
                                  : data.january
                                  ? data.january
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.february === "Open"
                                    ? "green-text"
                                    : data.february === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.february
                                    ? data.february
                                    : "-"
                                  : data.february
                                  ? data.february
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.march === "Open"
                                    ? "green-text"
                                    : data.march === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.march
                                    ? data.march
                                    : "-"
                                  : data.march
                                  ? data.march
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.april === "Open"
                                    ? "green-text"
                                    : data.april === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.april
                                    ? data.april
                                    : "-"
                                  : data.april
                                  ? data.april
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.may === "Open"
                                    ? "green-text"
                                    : data.may === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.may
                                    ? data.may
                                    : "-"
                                  : data.may
                                  ? data.may
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.june === "Open"
                                    ? "green-text"
                                    : data.june === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.june
                                    ? data.june
                                    : "-"
                                  : data.june
                                  ? data.june
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.july === "Open"
                                    ? "green-text"
                                    : data.july === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.july
                                    ? data.july
                                    : "-"
                                  : data.july
                                  ? data.july
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.august === "Open"
                                    ? "green-text"
                                    : data.august === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.august
                                    ? data.august
                                    : "-"
                                  : data.august
                                  ? data.august
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.september === "Open"
                                    ? "green-text"
                                    : data.september === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.september
                                    ? data.september
                                    : "-"
                                  : data.september
                                  ? data.september
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.october === "Open"
                                    ? "green-text"
                                    : data.october === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.october
                                    ? data.october
                                    : "-"
                                  : data.october
                                  ? data.october
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.november === "Open"
                                    ? "green-text"
                                    : data.november === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.november
                                    ? data.november
                                    : "-"
                                  : data.november
                                  ? data.november
                                  : "-"}
                              </TableCell>
                              <TableCell
                                className={
                                  data.december === "Open"
                                    ? "green-text"
                                    : data.december === "Closed"
                                    ? "red-text"
                                    : "black-text"
                                }
                              >
                                {data.status === "avg. temp (f)" ||
                                data.status === "avgprecipitation"
                                  ? data.december
                                    ? data.december
                                    : "-"
                                  : data.december
                                  ? data.december
                                  : "-"}
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      });
                    });
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={"5"}
                      style={{ textAlign: "center" }}
                      className="store-no-data"
                    >
                      {isLoading ? null : "No records found"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          ) : (null)} 
        </InfiniteScroll>
      </div>
    </div>
  );
});

export default Seasonality;
